module.exports = __webpack_public_path__ + "static/media/cancel.51422e33.svg";